<template>
  <div class="sidebar">
    <div class="logo">
      <router-link to="/">
        <img
          style="padding-top: 20px"
          src="@/assets/hp/img/logo.png"
          alt="logo"
        />
      </router-link>
    </div>
    <div class="navigation">
      <h3>他言語版</h3>
      <ul>
        <li>
          <router-link class="language" to="/">日本語</router-link>
        </li>
        <li>
          <router-link class="language" style="font-size: 12px" to="/english">
            English
          </router-link>
        </li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HpSidebar',
};
</script>

<style scoped>
/* サイドバー */
.sidebar {
  float: left;
  width: 11.8em;
  padding: 3px 1.5em 10px 1.3em;
  position: absolute;
}
.sidebar .logo {
  margin-bottom: 20px;
}
.sidebar .navigation {
  padding: 0.15em 0 0 0.45em;
}
.sidebar h3 {
  font-size: 0.75em;
  color: #4d4d4d;
  font-weight: normal;
  margin: 0.5em 0 0 0;
  padding: 0.25em 0;
  cursor: default;
  border: 0;
  border-bottom: 1px solid #d8d8d8;
}
.sidebar li {
  line-height: 1.125em;
  margin: 0;
  padding: 0.25em 0;
  font-size: 0.75em;
  word-wrap: break-word;
}
.sidebar .language {
}
</style>